import React from 'react';
import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DataIngestion = createSvgIcon(/*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    d: "M20 2H4C3 2 2 2.9 2 4V7.01C2 7.73 2.43 8.35 3 8.7V20C3 21.1 4.1 22 5 22H19C19.9 22 21 21.1 21 20V8.7C21.57 8.35 22 7.73 22 7.01V4C22 2.9 21 2 20 2ZM19 20H5V9H19V20ZM20 7H4V4H20V7Z",
    fill: "#999999"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15 12H9V14H15V12Z",
    fill: "#999999"
  })]
}), 'DataIngestion');
export var DataIngestionFilled = createSvgIcon(/*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    d: "M20 2H4C3 2 2 2.9 2 4V7.01C2 7.73 2.43 8.35 3 8.7V20C3 21.1 4.1 22 5 22H19C19.9 22 21 21.1 21 20V8.7C21.57 8.35 22 7.73 22 7.01V4C22 2.9 21 2 20 2ZM19 20H5V9H19V20ZM20 7H4V4H20V7Z",
    fill: "#0077D4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15 12H9V14H15V12Z",
    fill: "#0077D4"
  })]
}), 'DataIngestionFilled');
export var DataIngestionHover = createSvgIcon(/*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    d: "M20 2H4C3 2 2 2.9 2 4V7.01C2 7.73 2.43 8.35 3 8.7V20C3 21.1 4.1 22 5 22H19C19.9 22 21 21.1 21 20V8.7C21.57 8.35 22 7.73 22 7.01V4C22 2.9 21 2 20 2ZM19 20H5V9H19V20ZM20 7H4V4H20V7Z",
    fill: "#0077D4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15 12H9V14H15V12Z",
    fill: "#0077D4"
  })]
}), 'DataIngestionHover');